import React, { useEffect, useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input, notification, Row, Select, message } from "antd";
import IMAGES from "../../const/Image";
import { ForgotPassword } from "../../const/ForgotPassword/ForgotPassword";
import { Navigate, useNavigate } from "react-router-dom";
// import createService from "./createService";
import uuid from 'react-uuid';
import { login } from "../../Services/AuthServices";
import API_URL from "../../api/url";
// import Cookies from 'js-cookie';
import { useCookies , Cookies} from 'react-cookie';

export const Login = () => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filter, setFilter] = useState([]);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [cookies, setCookie, removeCookie] = useCookies(['Authorization'], {
    doNotParse: true,
  });
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      console.log("Received values of form ", values)
      if (values) {
        const payload = {
          'username': values.username,
          'password': values.password,
        }
        const res = await login(payload)

        if (res.status === 200) {
          console.log(res);
          navigate('/dashboard')
          notification.success({
            message: res?.data?.message
          });


          localStorage.setItem('Name', res?.data?.data?.name);
          localStorage.setItem("Role",res?.data?.data?.role);
          // console.log(Cookies.get('Authorization'));
          // setCookie("Authorization", cookies);
          // Cookies.get("Authorization")
          
          // // Cookies.set('', cookieValue);
          // Cookies.get('Authorization')
          // setCookie
          console.log("token",cookies.Authorization);
          console.log(document.cookie.split(';'));
          console.log(document.cookie);
          localStorage.setItem("accesstoken",document.cookie.split(';'));
        }
      }
    } catch (error) {
      console.log("Error during login", error)
    }
  }


  return (
    <>
      <div className="login-my-beauty m_c">
        
        
        <div className="Login-Page">
          <div className="Login-Form">
            <Form
              name="login"
              initialValues={{
                remember: true,
              }}
              style={{
                // width: 550,
                backgroundColor: "#fff",
                padding: "30px 50px",
                borderRadius: "20px",
                // boxShadow: "2px 2px 10px 2px #00000029",
              }}
              onFinish={onFinish}
            >              
              <Row className="LogIn-BMB-Logo">
                <img className="BMBLogo" src={IMAGES.LoginTaxiLogo} alt="" />
              </Row>

              <Form.Item
                label="Username"
                name="username"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter username",
                  }
                ]}
              >
                <Input
                  size="large"
                  prefix={<UserOutlined />}
                  placeholder="Username"
                />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter password",
                  },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Password"
                  size="large"
                />
              </Form.Item>              

              {/* <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <a onClick={showModal}>Forgot password?</a>
                </div>
              </Form.Item> */}

              <Form.Item>
                <Button block size="large" type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
        <div className="cldfooter">
          2025, Copyright 
          {/* <a href="javascript:void(0);" target="_blank" style="margin-left: 11px;">
            <img src="images/solz.png" style="margin-bottom: -4px;height: 18px;" alt="" />
          </a> */}
          </div>
      </div>
    </>
  );
};




